import { render } from "./EditRegisterModal.vue?vue&type=template&id=2bab15e2&scoped=true"
import script from "./EditRegisterModal.vue?vue&type=script&lang=js"
export * from "./EditRegisterModal.vue?vue&type=script&lang=js"

import "./EditRegisterModal.vue?vue&type=style&index=0&id=2bab15e2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bab15e2"]])

export default __exports__